// pages/mind-mesch/About.js

import React from 'react';

const About = () => {
  return (
    <div style={{ padding: '2rem', fontFamily: 'Segoe UI, sans-serif', color: '#2c3e50' }}>
      <h1>About Mind Mesch</h1>

      <section style={{ marginTop: '1.5rem', lineHeight: '1.7' }}>
        <p>
          Mind Mesch was created with a mission: to bring structure, clarity, and cognitive support to your daily flow.
          Whether you're tracking thoughts, embedding memory into workflows, or integrating partner tools, Mesch is built to scale with you.
        </p>

        <p style={{ marginTop: '1rem' }}>
          Designed by a solo founder with deep experience in software architecture and human-centric design,
          this platform combines performance engineering with a heart for thoughtful user experience.
        </p>

        <p style={{ marginTop: '1rem' }}>
          Mind Mesch is more than a product — it’s a philosophy: your mind, organized, empowered, and extended.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h3>How We Built It</h3>
        <ul style={{ marginTop: '0.75rem', lineHeight: '1.6' }}>
          <li>✔️ React frontend with precision UI components</li>
          <li>✔️ Node.js backend, API-ready</li>
          <li>✔️ PostgreSQL + MongoDB + Vector Memory in later phases</li>
          <li>✔️ Stripe integration for partners and power users</li>
        </ul>
      </section>

      <section style={{ marginTop: '2rem', fontSize: '0.9rem', color: '#7f8c8d' }}>
        <p>Mind Mesch is proudly built and maintained in the U.S. 🇺🇸</p>
      </section>
    </div>
  );
};

export default About;
